"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.WidgetPlacement = void 0;
exports.WidgetPlacement = {
    TopLeft: "top-left",
    Top: "top",
    TopRight: "top-right",
    BottomLeft: "bottom-left",
    Bottom: "bottom",
    BottomRight: "bottom-right",
};
